export default __webpack_public_path__ + "static/media/sample_1.86b7483c.png";